export default __webpack_public_path__ + "6806408aa1bf55b7f1aaba51978e649e.svg";